import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components';

import { FaFacebookF, FaInstagram, FaLinkedin, FaXTwitter } from 'react-icons/fa6';

import { Link } from 'react-router-dom';



const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="box-container">
        
          {/* Event Information & Social Media Links */}
          <div className="footer-item">

            {/* Event Logo */}
            <Logo />

            {/* Event Description */}
            <p>Join a premier event experience where professionals and innovators connect, share insights, and shape the future. Stay tuned for updates and exciting announcements.</p>

            {/* Social Media Links */}
           <div className='social'>
             <a href="/#"><FaFacebookF className='icon' /></a>
             <a href="/#"><FaXTwitter className='icon' /></a>
             <a href="/#"><FaInstagram className='icon' /></a>
             <a href="/#"><FaLinkedin className='icon' /></a>
           </div>

            {/* Newsletter component to subscribe */}
            <Newsletter variant='dark' idPrefix='2' />

          </div>

          {/* Quick Links */}
          <div className="footer-item">
            <div className="links">
              <p><Link to="/About-us">About Us</Link></p>
              <p><Link to="/Tickets">Tickets</Link></p>
              <p><Link to="/Speakers">Speakers</Link></p>
              <p><Link to="/ScheduleTab">Schedule</Link></p>
              <p><Link to="/Blog-grid">Blogs</Link></p>
              <p><Link to="/Contact-us">Contact Us</Link></p>
            </div>
          </div>

        </div>
      </div>

      {/* Footer Copyright */}
      <div className="content">
        <p>&copy; Eventia 2025 All Rights Reserved</p>
      </div>

    </footer>
  );
};

export default Footer;